import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import * as Icons from "@/assets/features/interview";
import { X } from "lucide-react";


export function ConfirmationModal({
  open,
  onOpenChange,
  trigger,
  icon = <Icons.ExclamationTriangle alt="icon" className="h-16 w-16" />,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  showCancel = true,
  confirmVariant = "default",
  confirmClassName,
  classNameFooter,
  loading
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
      <DialogContent className=" flex flex-col items-center w-lg my-10 rounded-[1rem]">
          <DialogClose asChild>
          <button
           onClick={() => onOpenChange(false)} 
            className="absolute right-4 top-4 rounded-full p-2 text-gray-500 hover:bg-gray-100 hover:text-black transition"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
        </DialogClose>


        <DialogHeader className=" text-black flex items-center justify-center my-5">
          <div className="flex justify-center mt-2 mb-1">{icon}</div>
          <DialogTitle className="font-semibold  text-center text-xl mx-5 capitalize mt-5">{title}</DialogTitle>
          {description&&<DialogDescription className="text-md lg:text-base mt-2 text-center w-75 text-black">
            {description}
          </DialogDescription>}
          
        </DialogHeader>
        {(onConfirm||showCancel)&&  <DialogFooter className={`flex justify-center gap-4 mb-[2.61rem] ${classNameFooter}`}>
          {onConfirm&& <Button
            variant={confirmVariant}
            className={`rounded-full
             capitalize px-13 py-5 ${confirmClassName}`}
            onClick={onConfirm}
            loading={loading}
          >
            {confirmLabel}
          </Button>}
          
          {showCancel && (
            <DialogClose asChild>
              <Button variant="outline" 
            className="px-9 h-[2.625rem] border-none !text-blue-300"
            onClick={() =>{onOpenChange(false); onCancel();}}
              
              >
                {cancelLabel}
              </Button>
            </DialogClose>
          )}
         
        </DialogFooter>}
      
      </DialogContent>
    </Dialog>
  )
}
